import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptionsArgs } from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class ImageUploadService {
    constructor(private http: Http){}

    uploadImage(data: any, imageType: string, fileName: string) {
        let headers: Headers = new Headers();
        headers.append("cache-control", "no-cache");
        let opts: RequestOptionsArgs = {headers: headers};
        var blob = this.dataURItoBlob(data.image);
        console.log(blob);
        let formData:FormData = new FormData();
        formData.append(imageType, blob, fileName);
        return this.http.post("/api/upload/image", formData, opts)
            .map((response: Response) => {
                return response.json();
            })

    }

    dataURItoBlob(dataURI) {
        var binary = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var array = [];
        for(var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {type: mimeString});
    };
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/services/Common/imageupload.service.ts